module.exports = "<fuse-profile-about *ngIf=\"!getMode()\"></fuse-profile-about>\n<fuse-edit-profile-forms *ngIf=\"getMode()\"></fuse-edit-profile-forms>"